<template>
  <div class="methodOfPayment">
    <div class="payment-title">
      <i class="el-icon-coin payment-title-icon"></i>
      收银台
    </div>
    <div class="payment-main">
      <div class="main-title">付款方式</div>
      <div class="paymain-wrapper">
        <div class="payment-radio">
          <div
            class="radio-item"
            v-show="alipay != 0"
            :class="alipayShow && !wxpayShow ? 'ali-active' : ''"
            @click="(alipayShow = true), (wxpayShow = false)"
          >
            <img
              class="icon"
              src="@/assets/image/MethodOfPayment/alipay-icon.png"
            />
            支付宝支付
            <img
              v-show="alipayShow && !wxpayShow"
              class="active-img"
              src="@/assets/image/MethodOfPayment/alipay_active.png"
              alt=""
            />
          </div>
          <div
            class="radio-item"
            v-show="wxpay != 0"
            :class="!alipayShow && wxpayShow ? 'wx-active' : ''"
            @click="(alipayShow = false), (wxpayShow = true)"
          >
            <img
              class="icon"
              src="@/assets/image/MethodOfPayment/wxpay-icon.png"
            />
            微信支付
            <img
              v-show="!alipayShow && wxpayShow"
              class="active-img"
              src="@/assets/image/MethodOfPayment/wxpay_active.png"
              alt=""
            />
          </div>
        </div>

        <div class="payCard" v-show="alipayShow && alipay == 1">
          <div class="payCard-title">应付金额</div>
          <div class="payCard-price">
            <span>¥</span>
            {{ amount }}
          </div>
          <div class="payCard-btn" @click="officialAlipay">确认支付</div>
        </div>

        <div
          class="qrcode"
          v-show="(alipayShow && alipay == 2) || (wxpayShow && wxpay != 0)"
        >
          <div class="qrcode-title">扫一扫付款 (元)</div>
          <div class="qrcode-price">
            ￥<span>{{ amount }}</span>
          </div>
          <div class="qrcode-bg">
            <div class="pay_qrcode" ref="par_qrcode"></div>
            <div class="qrcode-tip">
              <div class="ss-icon">
                <i class="el-icon-full-screen"></i>
                <i class="el-icon-minus"></i>
              </div>
              <div class="text">扫一扫继续支付</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  apiLianlianWxpay,
  apiLianlianAlipay,
  apiLianlianQuery,
  apiLianlianserveWxpay,
  apiLianlianserveAlipay,
  apiLianlianserveQuery,
  apiPaySwitch,
  apiPaydetail,
  apiPaypayserve,
  officialPay,
  officialQuery,
  aliLianLianEarnestPay,
  wxLianLianEarnestPay,
  earnestPayQuery,
} from "@/request/API";
import QRCode from "qrcodejs2";

export default {
  name: "MethodOfPayment",
  props: {},
  components: {},
  data() {
    return {
      alipayShow: true,
      wxpayShow: false,
      orderid: "",
      id: "",
      gameid: "",
      uniqueno: "",
      type: "",
      timer: null,
      amount: "",
      wxQrcode: "",
      aliQrcode: "",
      //微信支付
      wxpay: 0,
      //支付宝支付
      alipay: 0,
      earnest_order_id:''
    };
  },
  computed: {
    payment(){
      // lianlian  连连支付    offical 官方支付
      return (this.wxpayShow === true && this.alipay === 2) || (this.alipayShow === true && this.alipay === 2) ? "lianlian" :'offical'
    }
  },
  created() {
    this.type = this.$route.query.type + '';
    this.orderid = this.$route.query.orderid;
    this.id = this.$route.query.id;
    this.gameid = this.$route.query.gameid;
    this.amount = this.$route.query.amount;
    this.uniqueno = this.$route.query?.uniqueno;
    this.earnest_order_id = this.$route.query?.earnest_order_id || '';
    this.wxQrcode = "";
    this.aliQrcode = "";
  },
  async mounted() {
    let payswitch = await this.getPaySwitch();
    this.alipay = payswitch.alipay;
    this.wxpay = payswitch.wxpay;
    if (payswitch.alipay == 0) {
      this.wxpayShow = true;
      this.alipayShow = false;
    } else {
      this.payQrcode();
    }
    this.$WS.on("pc_alipay_serve_success", () => {
      clearInterval(this.timer);
      this.timer = null;
      this.goRouter()
    });
    //监听诚意买支付结果
    this.$WS.on("app_alipay_earnest_success", (e) => {
      if( e.data.out_trade_no == this.orderid ) {
        clearInterval(this.timer);
        this.timer = null;
        this.goRouter()
      }
    });
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    /**
     * @description: 跳转支付状态页
     * @return {*}
     */
    goRouter() {
      // type 1账号 2诚心卖  3诚意买（求降价）
      switch (this.type) {
        case '1':
          // 账号
          if(!this.earnest_order_id) {
            this.$router.push({
              path: "/payment",
              query:{
                orderid: this.orderid,
                id: this.id,
                game_id: this.gameid,
              },
            });
          } else {
            //  求降价付尾款
            this.$router.push({
            path: "/payResult",
            query: {
                orderid: this.earnest_order_id,
                payment: this.payment,
              },
            })
          }
          break;
        case '2':
          // 诚心卖 
          this.$router.push({
            path: "/sinceritypayment",
            query: {
              orderid: this.orderid,
              id: this.id,
              gameid: this.gameid,
              uniqueno: this.uniqueno,
            },
          });
          break;
        case '3':
          // 诚意买（求降价）
          this.$router.push({
            path: "/payResult",
            query: {
              orderid: this.orderid,
              id: this.id,
              game_id: this.gameid,
              payment: this.payment,
            },
          })
          break;
      }
    },
    /**
     * @description: 查询支付状态
     * @return {*}
     */
    selectPayStatus() {
      if(this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        // 调用查询支付状态接口
        switch (this.type) {
          // 账号
          case '1':
            apiLianlianQuery({
            id: this.orderid,
          }).then((res) => {
            if (res.data.code == 200) {
              clearInterval(this.timer);
              this.timer = null;
              this.goRouter();
            } else if (res.data.code == 10002) {
              clearInterval(this.timer);
              this.timer = null;
              this.$router.push({
                  path:'/personalCenter/buyer'
              });
            }
          })
            break;
          case '2':
            // 诚心卖
            apiLianlianserveQuery({
              id: this.orderid,
            }).then((res) => {
              if (res.data.code == 200) {
                clearInterval(this.timer);
                this.timer = null;
                this.goRouter()
              } else if (res.data.code == 10002) {
                clearInterval(this.timer);
                this.timer = null;
                this.$router.push({
                  path: "/personalCenter/seller/sincerity",
                });
              }
            })
            break;
          case '3':
            // 诚意买
            let API = {
              offical: officialQuery,
              lianlian: earnestPayQuery
            }
            // payment  lianlian  连连支付    offical 官方支付
            API[this.payment]({
              id:this.orderid
            }).then((res) => {
              if (res.data.code == 200) {
                clearInterval(this.timer);
                this.timer = null;
                this.goRouter()
              } else if (res.data.code == 10002) {
                //  失败跳至列表页
                clearInterval(this.timer);
                this.timer = null;
                this.$router.push({path:"/personalCenter/buyer/bargainPrice"})
              }
            })
            break;
        }
      }, 4000);
    },
    /**
     * @description: 生成二维码
     * @param {*} url
     * @return {*}
     */
    generateQrcode(url, type) {
      if (
          (this.wxpayShow && type === "wx") ||
          (this.alipayShow && type === "ali")
        ) {
          new QRCode(this.$refs.par_qrcode, {
            text: url,
            width: 250,
            height: 250,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
            correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
          });
        }
    },
    /**
     * @description: 获取支付链接
     * @return {*}
     */
    payQrcode() {
      clearInterval(this.timer);
      this.timer = null;
      if (this.$refs.par_qrcode) this.$refs.par_qrcode.innerHTML = "";

      if (this.alipayShow && !this.wxpayShow) {
        if (this.alipay == 2) {
          // 支付宝支付
          if (this.type == '1') {
            // 账号
            if (!this.aliQrcode) {
              apiLianlianAlipay({
                id: this.orderid,
              })
                .then((res) => {
                  this.aliQrcode = res.data.gateway_url;
                  this.generateQrcode(this.aliQrcode, "ali");
                  this.selectPayStatus();
                })
                .catch((e) => {
                  this.$message.error(e.msg);
                });
            } else {
              this.generateQrcode(this.aliQrcode, "ali");
              this.selectPayStatus();
            }
          } else if(this.type == '2') {
            // 诚心卖
            if (!this.aliQrcode) {
              apiLianlianserveAlipay({
                id: this.orderid,
              })
                .then((res) => {
                  this.aliQrcode = res.data.gateway_url;
                  this.generateQrcode(this.aliQrcode, "ali");
                  this.selectPayStatus();
                })
                .catch((e) => {
                  this.$message.error(e.msg);
                });
            } else {
              this.generateQrcode(this.aliQrcode, "ali");
              this.selectPayStatus();
            }
          } else {
            // 诚意买
            if (!this.aliQrcode) {
              aliLianLianEarnestPay({
                id: this.orderid,
              })
                .then((res) => {
                  this.aliQrcode = res.data.gateway_url;
                  this.generateQrcode(this.aliQrcode, "ali");
                  this.selectPayStatus();
                })
                .catch((e) => {
                  this.$message.error(e.msg);
                });
            } else {
              this.generateQrcode(this.aliQrcode, "ali");
              this.selectPayStatus();
            }
          }
        }
      } else {
        if (this.wxpay == 2) {
          // 微信支付
          if (this.type == '1') {
            // 账号
            if (!this.wxQrcode) {
              apiLianlianWxpay({
                id: this.orderid,
              })
                .then((res) => {
                  this.wxQrcode = res.data.gateway_url;
                  this.generateQrcode(this.wxQrcode, "wx");
                  this.selectPayStatus();
                })
                .catch((e) => {
                  this.$message.error(e.msg);
                });
            } else {
              this.generateQrcode(this.wxQrcode, "wx");
              this.selectPayStatus();
            }
          } else if(this.type=='2') {
            // 诚心卖
            if (!this.wxQrcode) {
              apiLianlianserveWxpay({
                id: this.orderid,
              })
                .then((res) => {
                  this.wxQrcode = res.data.gateway_url;
                  this.generateQrcode(this.wxQrcode, "wx");
                  this.selectPayStatus();
                })
                .catch((e) => {
                  this.$message.error(e.msg);
                });
            } else {
              this.generateQrcode(this.wxQrcode, "wx");
              this.selectPayStatus();
            }
          } else {
            // 诚意买
            if (!this.wxQrcode) {
              wxLianLianEarnestPay({
                id: this.orderid,
              })
                .then((res) => {
                  this.wxQrcode = res.data.gateway_url;
                  this.generateQrcode(this.wxQrcode, "wx");
                  this.selectPayStatus();
                })
                .catch((e) => {
                  this.$message.error(e.msg);
                });
            } else {
              this.generateQrcode(this.wxQrcode, "wx");
              this.selectPayStatus();
            }
          }
        }
      }
    },

    /**
     * 获取支付渠道
     */
    getPaySwitch() {
      var data
      switch (this.type) {
        case '1':
          data = { order_id: this.orderid }
          break;
        case '2':
          data = { serve_order_id: this.orderid }
          break;
        case '3':
          data = {earnest_order_id: this.orderid}
          break;
      }
      return new Promise((resolve, reject) => {
        apiPaySwitch({
          ...data,
        }).then((res) => {
          resolve(res.data);
        });
      });
    },
    /**
     * 官方支付宝支付
     */
    officialAlipay() {
      if (this.type == 1) {
        var return_url = `${process.env.VUE_APP_WEBSITE}/payment?orderid=${this.orderid}&id=${this.id}&game_id=${this.gameid}`
        if (this.earnest_order_id){
          return_url = `${process.env.VUE_APP_WEBSITE}/payResult?orderid=${this.orderid}&id=${this.id}&gameid=${this.gameid}`
        }
        apiPaydetail({
          id: this.orderid,
          return_url
        }).then((res) => {
          let alipayFrom = res.data.from_data;
          const div = document.createElement("divform");
          div.innerHTML = res.data.from_data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
          div.remove();
        }).catch((e) => {
            this.$message.error(e.msg);
        });
      } else if (this.type == 2) {
        apiPaypayserve({
          id: this.orderid,
          return_url: `${process.env.VUE_APP_WEBSITE}/sinceritypayment?orderid=${this.orderid}&id=${this.id}&gameid=${this.gameid}&uniqueno=${this.uniqueno}`,
        })
          .then((response) => {
            const div = document.createElement("divform");
            div.innerHTML = response.data.from_data;
            document.body.appendChild(div);
            document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
            document.forms[0].submit();
            div.remove();
          })
          .catch((e) => {
            this.$message.error(e.msg);
          });
      } else {
        officialPay({
          id: this.orderid,
          return_url: `${process.env.VUE_APP_WEBSITE}/payResult?orderid=${this.orderid}&id=${this.id}&gameid=${this.gameid}`,
          // return_url: `http://localhost:8080/payResult?orderid=${this.orderid}&id=${this.id}&gameid=${this.gameid}`,
        })
          .then((response) => {
            const div = document.createElement("divform");
            div.innerHTML = response.data.from_data;
            document.body.appendChild(div);
            document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
            document.forms[0].submit();
            div.remove();
          })
          .catch((e) => {
            this.$message.error(e.msg);
          })
      }
    },
  },
  watch: {
    alipayShow(v) {
      this.payQrcode();
    },
  },
  beforeDestroy() {
    if(this.timer) clearInterval(this.timer)
  }
};
</script>
<style lang='less' scoped>
.methodOfPayment {
  width: 1200px;
  max-width: calc(100vw - 48px);
  margin: 24px auto 0;
  padding: 0 0 40px;
  box-sizing: border-box;
  color: var(--text-main, #111827);

  .payment-title {
    width: 100%;
    height: 88px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    padding: 0 28px;
    box-sizing: border-box;
    font-size: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    box-shadow: 0 14px 30px rgba(26, 29, 36, 0.14);

    .payment-title-icon {
      flex: 0 0 auto;
      margin-right: 12px;
      width: 36px;
      height: 36px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.16);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #ffffff;
    }
  }

  .payment-main {
    width: 100%;
    background: var(--bg-card, #ffffff);
    padding: 28px 32px 48px;
    box-sizing: border-box;
    min-height: 640px;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-top: 0;
    border-radius: 0 0 4px 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .main-title {
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #111827);
      position: relative;
      text-indent: 16px;
      line-height: 26px;

      &::before {
        content: "";
        width: 4px;
        height: 18px;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        position: absolute;
        left: 0;
        top: 4px;
      }
    }

    .paymain-wrapper {
      padding-top: 22px;

      .payment-radio {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: 14px;

        .radio-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 210px;
          height: 76px;
          line-height: 1;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
          margin-right: 0;
          padding: 0 18px;
          background: var(--bg-card, #ffffff);
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          position: relative;
          cursor: pointer;
          overflow: hidden;
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, color 0.2s ease;

          &:hover {
            border-color: var(--primary, #FF5A1F);
            box-shadow: 0 10px 22px rgba(255, 90, 31, 0.10);
            color: var(--text-main, #111827);
          }

          .icon {
            flex: 0 0 auto;
            width: 36px;
            height: 36px;
            margin-right: 12px;
          }

          .active-img {
            position: absolute;
            right: 0;
            top: 0;
            width: 28px;
            height: 28px;
            clip-path: polygon(0 0, 100% 0, 0 100%);
          }
        }

        .radio-item:nth-of-type(1):hover {
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 10px 22px rgba(255, 90, 31, 0.12);
        }

        .radio-item:nth-of-type(2):hover {
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 10px 22px rgba(255, 90, 31, 0.12);
        }

        .ali-active {
          border-color: var(--primary, #FF5A1F);
          background: var(--bg-card, #ffffff);
          box-shadow: 0 12px 24px rgba(255, 90, 31, 0.12);
          color: var(--text-main, #111827);
        }

        .wx-active {
          border-color: var(--primary, #FF5A1F);
          background: var(--bg-card, #ffffff);
          box-shadow: 0 12px 24px rgba(255, 90, 31, 0.12);
          color: var(--text-main, #111827);
        }
      }

      .qrcode {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 392px;
        min-height: 488px;
        margin: 38px auto 0;
        padding: 30px 34px 28px;
        box-sizing: border-box;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        background: var(--bg-card, #ffffff);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        font-family: PingFang SC-Semibold, PingFang SC;

        .qrcode-title {
          font-size: 18px;
          font-weight: 600;
          color: var(--text-main, #111827);
          line-height: 26px;
        }

        .qrcode-price {
          color: var(--primary, #FF5A1F);
          font-size: 18px;
          margin: 8px 0 18px;
          line-height: 40px;

          span {
            font-size: 33px;
            font-weight: 700;
          }
        }

        .qrcode-bg {
          width: 314px;
          min-height: 362px;
          padding: 10px 0 0;
          box-sizing: border-box;
          border-radius: 0;
          background: transparent;

          .pay_qrcode {
            width: 250px;
            height: 250px;
            padding: 10px;
            margin: 0 auto;
            box-sizing: content-box;
            border-radius: 4px;
            background: #ffffff;
            border: 1px solid var(--border-soft, #E8E4DE);
            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);

            /deep/ img,
            /deep/ canvas {
              display: block;
              width: 100% !important;
              height: 100% !important;
            }
          }

          .qrcode-tip {
            margin-top: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--text-secondary, #5A5F6B);

            .ss-icon {
              position: relative;
              width: 32px;
              height: 32px;
              color: var(--primary, #FF5A1F);

              i {
                position: absolute;
                top: 0;
                left: 0;
                font-size: 32px;
              }
            }

            .text {
              margin-left: 12px;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              line-height: 20px;
            }
          }
        }
      }

      .payCard {
        width: 392px;
        min-height: 236px;
        background: var(--bg-card, #ffffff);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 72px auto 0;
        padding: 30px 34px;
        box-sizing: border-box;

        &-title {
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: var(--text-main, #111827);
          line-height: 26px;
        }

        &-price {
          font-size: 33px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 700;
          color: var(--primary, #FF5A1F);
          margin: 10px 0 30px;
          line-height: 40px;

          span {
            font-size: 18px;
            font-weight: 600;
          }
        }

        &-btn {
          width: 100%;
          height: 50px;
          line-height: 50px;
          background: var(--primary, #FF5A1F);
          border-radius: 3px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          cursor: pointer;
          box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
          transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

          &:hover {
            background: var(--primary-hover, #E84A12);
            box-shadow: 0 12px 24px rgba(255, 90, 31, 0.26);
            transform: translateY(-1px);
          }

          &:active {
            transform: translateY(0);
            box-shadow: 0 6px 14px rgba(255, 90, 31, 0.20);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .methodOfPayment {
    max-width: calc(100vw - 24px);
    margin-top: 16px;
    padding-bottom: 28px;

    .payment-title {
      height: 72px;
      padding: 0 20px;
      font-size: 18px;
    }

    .payment-main {
      padding: 22px 18px 32px;
      min-height: 560px;

      .paymain-wrapper {
        .payment-radio {
          gap: 10px;

          .radio-item {
            width: 100%;
            height: 68px;
          }
        }

        .qrcode,
        .payCard {
          width: 100%;
          margin-top: 28px;
          padding: 24px 20px;
        }

        .qrcode {
          min-height: 446px;

          .qrcode-bg {
            width: 100%;
            min-height: 322px;
            padding: 8px 0 0;

            .pay_qrcode {
              width: 220px;
              height: 220px;
              margin: 0 auto;
            }
          }
        }
      }
    }
  }
}
</style>
